// extracted by mini-css-extract-plugin
export default {"desktop":"statement_desktop__CLWwu","breadcrumbs":"statement_breadcrumbs__je3Ww","mobile":"statement_mobile__DNXAp","loader":"statement_loader__dWaQL"};